import { awaitSkiko, loadedWasm } from './skiko.mjs';

let compatibilityReady;

export function initializeSkikoWebkitCompatibility() {
    const userAgent = navigator.userAgent;
    // Keep CriOS/FxiOS enabled: those iOS browser variants use WebKit too.
    const isWebKit = /AppleWebKit\//.test(userAgent) && !/(Chrome|Chromium|Edg|OPR)\//.test(userAgent);
    if (!isWebKit) return Promise.resolve();

    compatibilityReady ||= awaitSkiko.then(() => {
        const nativeExports = loadedWasm._;
        const wrappers = new Map();
        let completedCalls = 0;
        // Wrapping only drawing exports left Safari transforms and images corrupted.
        // An empty proxy target avoids the read-only property invariants of Wasm exports.
        loadedWasm._ = new Proxy(Object.create(null), {
            get(_, key) {
                const original = nativeExports[key];
                if (typeof original !== 'function') return original;
                if (!wrappers.has(key)) {
                    wrappers.set(key, (...args) => {
                        // Keep work after the native call: return-only wrappers reproduced corruption.
                        try {
                            return original(...args);
                        } finally {
                            completedCalls += 1;
                        }
                    });
                }
                return wrappers.get(key);
            },
        });
        console.info('[Web renderer] WebKit native-call compatibility enabled: return-frame bridge');
        // Expose the counter so the post-call work remains observable.
        return { get completedCalls() { return completedCalls; } };
    });
    return compatibilityReady;
}
